
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { Bar, mixins } from "vue-chartjs";
import { Chart as ChartJS, Tooltip, LinearScale } from 'chart.js'

@Component
export default class VerticalBarChart extends Mixins(
    Bar,
    mixins.reactiveProp
) {
  @Prop()
  chartData: any; 
  @Prop()
  options: any;

  mounted(): void {
    if (this.chartData) {
      this.renderChart(this.chartData, this.options);
    }
  }
  @Watch("chartData")
  onChangeData(): void {
    if (this.chartData) {
      this.renderChart(this.chartData, this.options);
    }
  }
}
